'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, Hero, LayoutContainer, TextPassage } from '@petsmart-ui/sparky';
import { JobDetailsTable } from '@/components/Homepage/JobDetails/JobDetailsTable';
import { PromoOfferTable } from '@/components/Homepage/PromoOffer/PromoOfferTable';
import { usePermissions, usePromoJobs } from '@/hooks';
import './homepage.scss';
export function Homepage() {
  const $ = _c(12);
  const {
    promoJobs,
    jobDetails,
    isJobsLoading
  } = usePromoJobs();
  const {
    canAccessPromoJobs,
    canAccessBulkPromo,
    isLoading
  } = usePermissions();
  if (isLoading) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Hero imgSrc="nothing-here" imgAlt="No image here" className="homepage-hero"><Heading tagName="h1">Merchant Utilities</Heading><TextPassage className="sparky-u-margin-top-lg">A toolkit for PetSmart Merchants to interact with the eCommerce platform.</TextPassage></Hero>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== canAccessPromoJobs || $[2] !== isJobsLoading || $[3] !== promoJobs) {
    t1 = canAccessPromoJobs && <PromoOfferTable isJobsLoading={isJobsLoading} promoJobs={promoJobs} />;
    $[1] = canAccessPromoJobs;
    $[2] = isJobsLoading;
    $[3] = promoJobs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== canAccessBulkPromo || $[6] !== isJobsLoading || $[7] !== jobDetails) {
    t2 = canAccessBulkPromo && <JobDetailsTable isJobsLoading={isJobsLoading} jobDetails={jobDetails} />;
    $[5] = canAccessBulkPromo;
    $[6] = isJobsLoading;
    $[7] = jobDetails;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <LayoutContainer className="homepage-layout-container">{t0}{t1}{t2}</LayoutContainer>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}